import Myorder_Approved from "../assets/images/MyOrders/Myorder_Approved.svg"
import Myorder_Pending_Approval from "../assets/images/MyOrders/Myorder_Pending_Approval.svg";
import Myorder_Rejected from "../assets/images/MyOrders/Myorder_Rejected-1.svg";
import Returned_to_Requester from "../assets/images/MyOrders/Myorder_Returned_to_Requester.svg";
import Myorder_Unsubmitted from "../assets/images/MyOrders/Myorder_Unsubmitted.svg";
import POCreation from "../assets/images/PO Creation.svg";
import Cancelled from "../assets/images/MyOrders/Cancelled.svg";
import Deleted from "../assets/images/MyOrders/Deleted.png";
import Fleet_Processing from "../assets/images/MyOrders/Fleet Processing.svg";
import Setup from "../assets/images/Setup.svg"
import Finance from "../assets/images/MyOrders/Finance.svg"
import Asset_Master_Set_Up from '../assets/images/Asset_Master_Set-Up.svg'
import Submitted_To_Fleet from '../assets/images/Submitted to Fleet.svg'
import fuel_Card from '../assets/images/Fuel_card_New.svg'
import New_Finance_item from '../assets/images/New Finance Item.svg'
import { CONSTANTS } from "./constants";
import Receive_Bos_Payment from '../assets/images/Receive_Bos_Payment.svg'
import Branch_Verification from '../assets/images/Branch Verification.svg'
import cost_payment_title from '../assets/images/cost_payment_title.svg'
import Requisition_Complete from '../assets/images/RequisitionCompleted.svg'
import Payment_Processing from '../assets/images/Payment_Processing.svg'
import License_And_Title from '../assets/images/License_And_Title.svg'
import CIP_Lease from '../assets/images/CIP_Lease.svg'
import Lease_Portfolio_Setup from '../assets/images/Lease_Portfolio_Setup.svg'
import ReceiveInvoice from "../assets/images/Receive Invoice.svg";
import NewFinanceItem from "../assets/images/New Finance Item.svg";
import missing_data from '../assets/images/Missing Data.svg'
import receive_sos_payment from '../assets/images/SOS Payment.svg'
import process_title from '../assets/images/Process title.svg'
import Process_Title_Registration from '../assets/images/Process title.svg'
import Process_Title from '../assets/images/Process title.svg'
import WebCenter_Setup from '../assets/images/Fleet WebCenter.svg'
import Fleet_WebCenter from '../assets/images/Fleet WebCenter.svg'
import Fixed_Asset_Queue from '../assets/images/fixed assets queue.svg'
import Pending from "../assets/images/Myorder_Pending Approval.png";
import pending_delivery from '../assets/images/Pending Delivery.svg';
import process_complete from '../assets/images/Process complete.svg';
import upfit_Preperation from '../assets/images/Upfit Preparation.svg';
import Fixed_Assets from '../assets/images/Fixed Assets.svg';
import Fleet_Activity from '../assets/images/Fleet Activity.svg';
import UNIT_Termination from '../assets/images/Unit Termination.svg';
import FUEL_Card_Setup from '../assets/images/Fuel Card Setup.svg';
import Carb_Setup from '../assets/images/Carb Setup.svg';
import E1_Asset_Setup from '../assets/images/E1 Asset Setup.svg'
import Transfer_State_Title from '../assets/images/Transfer State.svg'
import Costs_Term_Notice from '../assets/images/Costs, Term Notice.svg'
import Pricing_Buyer_INFO from '../assets/images/Pricing, Buyer Info.svg'
import Receive_Send_Term_Payment_Title from '../assets/images/Receive-Send Term, Payment.svg';
import Send_Receive_Donation_Agreement from '../assets/images/Send-Receive Donation Agreement.svg'
import E1_Update from "../assets/images/E1 Update.svg"
import Update_Registration from '../assets/images/Update Registration.svg'
import E1_Receive_PO from '../assets/images/E1 Receive PO.svg'
import Asset_Determination from '../assets/images/Asset Determination.svg'
import Asset_Reactivation_Setup from '../assets/images/Asset Reactivation Setup.svg'
import FLEET_WEBCENTER from '../assets/images/Fleet Web Center.svg'
import ONE_WORLD_UPDATE from '../assets/images/One World Update.svg'
import AFE_Invoice_Review from '../assets/images/AFE Invoice Review.svg'

export const GetStatusIcon = (status: any) => {
  let src = {
    icon: "",
    status: ""
  };
  switch (status) {
    case CONSTANTS.ITEM_STATUS.ONE_WORLD_UPDATE:
      src.icon = ONE_WORLD_UPDATE
      src.status = CONSTANTS.ITEM_STATUS.ONE_WORLD_UPDATE
      break;
    case CONSTANTS.ITEM_STATUS.FLEET_WEBCENTER:
      src.icon = FLEET_WEBCENTER
      src.status = CONSTANTS.ITEM_STATUS.FLEET_WEBCENTER
      break;
    case CONSTANTS.ITEM_STATUS.Asset_Reactivation_Setup:
      src.icon = Asset_Reactivation_Setup
      src.status = CONSTANTS.ITEM_STATUS.Asset_Reactivation_Setup
      break;
    case CONSTANTS.ITEM_STATUS.Asset_Determination:
      src.icon = Asset_Determination
      src.status = CONSTANTS.ITEM_STATUS.Asset_Determination
      break;
    case CONSTANTS.ITEM_STATUS.E1_Receive_PO:
      src.icon = E1_Receive_PO
      src.status = CONSTANTS.ITEM_STATUS.E1_Receive_PO
      break;
    case CONSTANTS.ITEM_STATUS.Update_Registration:
      src.icon = Update_Registration
      src.status = CONSTANTS.ITEM_STATUS.Update_Registration
      break;
    case CONSTANTS.ITEM_STATUS.Send_Receive_Donation_Agreement:
      src.icon = Send_Receive_Donation_Agreement
      src.status = CONSTANTS.ITEM_STATUS.Send_Receive_Donation_Agreement
      break;
    case CONSTANTS.ITEM_STATUS.E1_Update:
      src.icon = E1_Update
      src.status = CONSTANTS.ITEM_STATUS.E1_Update
      break;
    case CONSTANTS.ITEM_STATUS.Receive_Send_Term_Payment_Title:
     case CONSTANTS.ITEM_STATUS.Receive_Term_Notice_Payment: 
      src.icon = Receive_Send_Term_Payment_Title
      src.status = CONSTANTS.ITEM_STATUS.Receive_Send_Term_Payment_Title
      break;
    case CONSTANTS.ITEM_STATUS.Pricing_Buyer_INFO:
      src.icon = Pricing_Buyer_INFO
      src.status = CONSTANTS.ITEM_STATUS.Pricing_Buyer_INFO
      break;
    case CONSTANTS.ITEM_STATUS.Costs_Term_Notice:
      src.icon = Costs_Term_Notice
      src.status = CONSTANTS.ITEM_STATUS.Costs_Term_Notice
      break;
    case CONSTANTS.ITEM_STATUS.Transfer_State_Title:
      src.icon = Transfer_State_Title
      src.status = CONSTANTS.ITEM_STATUS.Transfer_State_Title
      break;
    case CONSTANTS.ITEM_STATUS.E1_Asset_Setup:
      src.icon = E1_Asset_Setup
      src.status = CONSTANTS.ITEM_STATUS.E1_Asset_Setup
      break;
    case CONSTANTS.ITEM_STATUS.Carb_Setup:
      src.icon = Carb_Setup
      src.status = CONSTANTS.ITEM_STATUS.Carb_Setup
      break;
    case CONSTANTS.ITEM_STATUS.FUEL_Card_Setup:
      src.icon = FUEL_Card_Setup
      src.status = CONSTANTS.ITEM_STATUS.FUEL_Card_Setup
      break;
    case CONSTANTS.ITEM_STATUS.UNIT_Termination:
      src.icon = UNIT_Termination
      src.status = CONSTANTS.ITEM_STATUS.UNIT_Termination
      break;
    case CONSTANTS.ITEM_STATUS.Fleet_Activity:
      src.icon = Fleet_Activity
      src.status = CONSTANTS.ITEM_STATUS.Fleet_Activity
      break;
    case CONSTANTS.ITEM_STATUS.Fixed_Assets:
      src.icon = Fixed_Assets
      src.status = CONSTANTS.ITEM_STATUS.Fixed_Assets
      break;
    case CONSTANTS.ITEM_STATUS.Upfit_Preparation:
    case CONSTANTS.ITEM_STATUS.Pending_Upfit_Completion:
      src.icon = upfit_Preperation
      src.status = CONSTANTS.ITEM_STATUS.Upfit_Preparation
      break
    case CONSTANTS.ITEM_STATUS.Asset_Master_Set_Up:
      src.icon = Asset_Master_Set_Up
      src.status = CONSTANTS.ITEM_STATUS.Asset_Master_Set_Up
      break;
    case CONSTANTS.ITEM_STATUS.Fuel_Card_Barcode_Assignment:
      src.icon = Setup
      src.status = CONSTANTS.ITEM_STATUS.Fuel_Card_Barcode_Assignment
      break;
    case CONSTANTS.ITEM_STATUS.Barcode_Assignment:
      src.icon = Setup
      src.status = CONSTANTS.ITEM_STATUS.Barcode_Assignment
      break;
    case CONSTANTS.ITEM_STATUS.Receive_Invoice:
      src.icon = ReceiveInvoice
      src.status = CONSTANTS.ITEM_STATUS.Receive_Invoice
      break;
    case CONSTANTS.ITEM_STATUS.Submitted_Finance:
      src.icon = New_Finance_item
      src.status = CONSTANTS.ITEM_STATUS.Submitted_Finance
      break;
    case CONSTANTS.ITEM_STATUS.Process_Complete:
      src.icon = process_complete
      src.status = CONSTANTS.ITEM_STATUS.Process_Complete
      break;
    case CONSTANTS.ITEM_STATUS.Fuel_Card:
      src.icon = fuel_Card
      src.status = CONSTANTS.ITEM_STATUS.Fuel_Card
      break;
    case CONSTANTS.ITEM_STATUS.Asset_Setup:
      src.icon = Setup
      src.status = CONSTANTS.ITEM_STATUS.Asset_Setup
      break;
    case CONSTANTS.ITEM_STATUS.Pending_Delivery:
      src.icon = pending_delivery
      src.status = CONSTANTS.ITEM_STATUS.Pending_Delivery
      break;
    case CONSTANTS.ITEM_STATUS.Pending:
      src.icon = Pending
      src.status = CONSTANTS.ITEM_STATUS.Pending
      break;
    case CONSTANTS.ITEM_STATUS.Fixed_Asset_Queue:
      src.icon = Fixed_Asset_Queue
      src.status = CONSTANTS.ITEM_STATUS.Fixed_Asset_Queue
      break;
    case CONSTANTS.ITEM_STATUS.LEASE_SET_UP:
    case CONSTANTS.ITEM_STATUS.Lease_Setup_Up:  
      src.icon = CIP_Lease
      src.status = CONSTANTS.ITEM_STATUS.LEASE_SET_UP
      break;
    case CONSTANTS.ITEM_STATUS.Payment_Processing:
      src.icon = Payment_Processing
      src.status = CONSTANTS.ITEM_STATUS.Payment_Processing
      break;
    case CONSTANTS.ITEM_STATUS.Order_Processing:
      src.icon = New_Finance_item
      src.status = CONSTANTS.ITEM_STATUS.NEW_FINANCE_ITEM
      break;
    case CONSTANTS.ITEM_STATUS.License_and_Title:
      src.icon = License_And_Title
      src.status = CONSTANTS.ITEM_STATUS.License_and_Title
      break;
    case CONSTANTS.ITEM_STATUS.Fleet_WebCenter:
      src.icon = Fleet_WebCenter
      src.status = CONSTANTS.ITEM_STATUS.Fleet_WebCenter
      break;
    case CONSTANTS.ITEM_STATUS.Lease_Portfolio_Set_Up:
      src.icon = Lease_Portfolio_Setup
      src.status = CONSTANTS.ITEM_STATUS.Lease_Portfolio_Set_Up
      break;
    case CONSTANTS.ITEM_STATUS.WebCenter_Setup:
      src.icon = WebCenter_Setup
      src.status = CONSTANTS.ITEM_STATUS.WebCenter_Setup
      break;
    case CONSTANTS.ITEM_STATUS.Process_Title:
      src.icon = Process_Title
      src.status = CONSTANTS.ITEM_STATUS.Process_Title
      break;
    case CONSTANTS.ITEM_STATUS.Process_Title_Registration:
      src.icon = Process_Title_Registration
      src.status = CONSTANTS.ITEM_STATUS.Process_Title_Registration
      break;
    case CONSTANTS.ITEM_STATUS.Receive_BOS_Payment_Title:
      src.icon = Receive_Bos_Payment
      src.status = CONSTANTS.ITEM_STATUS.Receive_BOS_Payment_Title
      break;
    case CONSTANTS.ITEM_STATUS.Title:
      src.icon = process_title
      src.status = CONSTANTS.ITEM_STATUS.Title
      break;
    case CONSTANTS.ITEM_STATUS.Receive_SOS_Payment:
      src.icon = receive_sos_payment
      src.status = CONSTANTS.ITEM_STATUS.Receive_SOS_Payment
      break;
    case CONSTANTS.ITEM_STATUS.Costs_Payment_Title:
      src.icon = cost_payment_title
      src.status = CONSTANTS.ITEM_STATUS.Costs_Payment_Title
      break;
    case CONSTANTS.ITEM_STATUS.Cost_Payment_Title:
      src.icon = cost_payment_title
      src.status = CONSTANTS.ITEM_STATUS.Cost_Payment_Title
      break;
    case CONSTANTS.ITEM_STATUS.Missing_Data:
      src.icon = missing_data
      src.status = CONSTANTS.ITEM_STATUS.Missing_Data
      break;
    case CONSTANTS.ITEM_STATUS.SUBMITTED_TO_FINANCE:
      src.icon = NewFinanceItem
      src.status = CONSTANTS.ITEM_STATUS.SUBMITTED_TO_FINANCE
      break;
    case CONSTANTS.ITEM_STATUS.REQUISITION_COMPLETE:
      src.icon = Requisition_Complete
      src.status = CONSTANTS.ITEM_STATUS.REQUISITION_COMPLETE
      break;
    case CONSTANTS.ITEM_STATUS.PO_CREATION:
      src.icon = POCreation
      src.status = CONSTANTS.ITEM_STATUS.PO_CREATION
      break;
    case CONSTANTS.ITEM_STATUS.Branch_Verification:
      src.icon = Branch_Verification
      src.status = CONSTANTS.ITEM_STATUS.Branch_Verification
      break;
    case CONSTANTS.ITEM_STATUS.Receive_Bos_Payment:
    case CONSTANTS.ITEM_STATUS.Receive_BOS_Payment:  
    case CONSTANTS.ITEM_STATUS.Receive_BosPayment:
    case CONSTANTS.ITEM_STATUS.Receive_BOS_Payments:
    case CONSTANTS.ITEM_STATUS.Receive_BOS:
    case CONSTANTS.ITEM_STATUS.Receive_Payment:
      src.icon = Receive_Bos_Payment
      src.status = CONSTANTS.ITEM_STATUS.Receive_Bos_Payment
      break;
    case CONSTANTS.ITEM_STATUS.NEW_FINANCE_ITEM:
    case CONSTANTS.ITEM_STATUS.New_Fleet_Item:
      src.icon = New_Finance_item
      src.status = CONSTANTS.ITEM_STATUS.NEW_FINANCE_ITEM
      break;
    case CONSTANTS.ITEM_STATUS.FUEL_CARD_TAG_AND_TITLE:
      src.icon = fuel_Card
      src.status = CONSTANTS.ITEM_STATUS.FUEL_CARD_TAG_AND_TITLE
      break;
    case CONSTANTS.ITEM_STATUS.SUBMITTED_TO_FLEET:
      src.icon = Submitted_To_Fleet;
      src.status = CONSTANTS.ITEM_STATUS.SUBMITTED_TO_FLEET
      break;
    case CONSTANTS.ORDER_STATUS.PENDING_APPROVAL:
      src.icon = Myorder_Pending_Approval;
      src.status = CONSTANTS.ORDER_STATUS.PENDING_APPROVAL
      break;
    case CONSTANTS.ORDER_STATUS.COMPLETED:
      src.icon = Myorder_Approved;
      src.status = CONSTANTS.ORDER_STATUS.COMPLETED
      break;
    case CONSTANTS.ORDER_STATUS.SUBMITTED:
      src.icon = Myorder_Approved;
      src.status = CONSTANTS.ORDER_STATUS.SUBMITTED
      break;
    case CONSTANTS.ORDER_STATUS.REJECTED:
    case CONSTANTS.ORDER_STATUS.DENIED:
      src.icon = Myorder_Rejected;
      src.status = CONSTANTS.ORDER_STATUS.DENIED
      break;
    case CONSTANTS.ORDER_STATUS.FLEET_PROCESSING:
      src.icon = Fleet_Processing;
      src.status = CONSTANTS.ORDER_STATUS.FLEET_PROCESSING
      break;
    case CONSTANTS.ORDER_STATUS.PROCESSING:
      src.icon = Fleet_Processing;
      src.status = CONSTANTS.ORDER_STATUS.PROCESSING
      break;
    case CONSTANTS.ORDER_STATUS.RETURNED:
    case CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR:
      src.icon = Returned_to_Requester;
      src.status = CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR
      break;
    case CONSTANTS.ORDER_STATUS.UNSUBMITTED:
    case CONSTANTS.ORDER_STATUS.SAVED:
      src.icon = Myorder_Unsubmitted;
      src.status = CONSTANTS.ORDER_STATUS.UNSUBMITTED
      break;
    case CONSTANTS.ORDER_STATUS.NEW:
      src.icon = Myorder_Unsubmitted;
      src.status = CONSTANTS.ORDER_STATUS.NEW
      break;
    case CONSTANTS.ORDER_STATUS.CANCELLED:
      src.icon = Cancelled;
      src.status = CONSTANTS.ORDER_STATUS.CANCELLED
      break
    case CONSTANTS.ITEM_STATUS.FLEET_SETUP:
      src.icon = Setup;
      src.status = CONSTANTS.ITEM_STATUS.FLEET_SETUP
      break;
    case CONSTANTS.ITEM_STATUS.PROGRAMS_UPDATE:
      src.icon = POCreation;
      src.status = CONSTANTS.ITEM_STATUS.PROGRAMS_UPDATE;
      break;
    case CONSTANTS.ITEM_STATUS.ASSET_REACTIVATION_SETUP:
      src.icon = POCreation;
      src.status = CONSTANTS.ITEM_STATUS.ASSET_REACTIVATION_SETUP;
      break;
    case CONSTANTS.ITEM_STATUS.SUBMITTED_to_FINANCE:
      src.icon = Finance;
      src.status = CONSTANTS.ITEM_STATUS.SUBMITTED_TO_FINANCE
      break;
    case CONSTANTS.ITEM_STATUS.TRANSFER_COMPLETE:
      src.icon = Myorder_Approved;
      src.status = CONSTANTS.ITEM_STATUS.TRANSFER_COMPLETE
      break;
    case CONSTANTS.ITEM_STATUS.DISPOSITION_COMPLETE:
      src.icon = Myorder_Approved;
      src.status = CONSTANTS.ITEM_STATUS.DISPOSITION_COMPLETE
      break;
    case CONSTANTS.ITEM_STATUS.REACTIVATION_COMPLETE:
      src.icon = Myorder_Approved;
      src.status = CONSTANTS.ITEM_STATUS.REACTIVATION_COMPLETE
      break;
    case CONSTANTS.ITEM_STATUS.AFE_COMPLETE:
      src.icon = Myorder_Approved;
      src.status = CONSTANTS.ITEM_STATUS.AFE_COMPLETE
      break;
    case CONSTANTS.ORDER_STATUS.DELETED:
      src.icon = Deleted;
      src.status = CONSTANTS.ORDER_STATUS.DELETED
      break;
    case CONSTANTS.ITEM_STATUS.EONE_SET_UP:
      src.icon = Asset_Master_Set_Up;
      src.status = CONSTANTS.ITEM_STATUS.EONE_SET_UP
      break;
    case CONSTANTS.ITEM_STATUS.AFE_Invoice_Review:
      src.icon = AFE_Invoice_Review;
      src.status = CONSTANTS.ITEM_STATUS.AFE_Invoice_Review;
      break;
    default:
      src.status = status;
      break;
  }
  return src;
};
